import axios from "axios"
import { useEffect, useState } from "react"
import { Fade } from "react-awesome-reveal"
import PageLoader from "../../components/global/loader/PageLoader"
import { AttorneysSection } from "../../components/home/AttorneysSection"
import { InternalBanner } from "../../components/internals/InternalBanner"
import './styles.scss';

export const Attorneys = () => {
    const [isFetchingPageData, setIsFetchingPageData] = useState(false);
    const [pageContent, setPageContent] = useState(null);

    useEffect(() => {
        fetchPageContent();
    }, []);

    const fetchPageContent = async () => {
        setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=lawyers`);
            setPageContent(data);
            if (data?.yoast_title?.length > 0) {
                document.title = data?.yoast_title;
            } else {
                document.title = data?.page?.post_title ? `${data?.page?.post_title}` : "Our Lawyers - Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
            }
            if (document.querySelector('#wp-admin-bar-edit a')) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }

    return  <Fade delay={1}>
        <main id="main" className="internal-page">
            {
                !isFetchingPageData && <>            
                    <InternalBanner page={pageContent?.page} />
                    {pageContent?.page_content?.length > 5 && <section id="main-article-content">               
                        <div className="container">
                            <article dangerouslySetInnerHTML={{__html: pageContent?.page_content }}></article>
                        </div>
                    </section>}
                    <AttorneysSection fields={pageContent?.fields} />
                </>
            }
            {
                isFetchingPageData && <PageLoader />
            }
        </main>
    </Fade>
}